"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LobbyCheckStatus = void 0;
var LobbyCheckStatus;
(function (LobbyCheckStatus) {
    LobbyCheckStatus["Active"] = "active";
    LobbyCheckStatus["Started"] = "started";
    LobbyCheckStatus["NotFound"] = "not_found";
})(LobbyCheckStatus || (exports.LobbyCheckStatus = LobbyCheckStatus = {}));
